/** @jsx jsx */
import { jsx } from '@emotion/core';
import { useMemo, useState } from 'react';

import Button, { ButtonProps } from 'components/Button';
import useIovation from 'hooks/useIovation';
import Link from 'components/Link';

function IovationButton<C extends 'button' | 'a' | typeof Link>(
  props: ButtonProps<C>,
) {
  const { disabled, ...rest } = props;
  const Iovation = useIovation();
  const [iovationFailed, setIovationFailed] = useState<boolean>(false);
  useMemo(() => {
    if (Iovation) Iovation.catch(_ => setIovationFailed(true));
  }, [Iovation]);

  return <Button disabled={disabled || iovationFailed} {...rest}></Button>;
}

export default IovationButton;
